import React from 'react';
import TableColumnTitle from '../../../../components/_table/TableColumnTitle';
import TableColumnImg from '../../../../components/table/TableColumnImg';
import Anchor from '../../../../components/link/Anchor';
import { TAG_RELATED_ITEM_TYPE } from '../../../../constants/service/app/tagConstants';
import { setNumberWithComma } from '../../../../lib/common';
import { setDateFormat } from '../../../../lib/moment';

/**
 *  태그에 연결된 아이템 컬림
 */
export const tagRelatedItemColumns = (data) => {
  const { tagRelatedItemType } = data;

  let columns = [];

  /**
   *  이미지 컬럼
   */
  const imgColumn = {
    title: <TableColumnTitle title={'이미지'} />,
    dataIndex: 'url',
    render: (value) => <TableColumnImg url={value} width={'60px'} height={'60px'} />,
  };

  /**
   *  태그에 연결된 아이템 타입 === 상품(0)
   */
  if (tagRelatedItemType === TAG_RELATED_ITEM_TYPE.PRODUCT) {
    columns = [imgColumn, ...productColumns(data)];
  } else if (tagRelatedItemType === TAG_RELATED_ITEM_TYPE.STORE) {
    /**
     *  태그에 연결된 아이템 타입 === 브랜드(1)
     */
    columns = [imgColumn, ...storeColumns(data)];
  } else if (tagRelatedItemType === TAG_RELATED_ITEM_TYPE.EVENT) {
    /**
     *  태그에 연결된 아이템 타입 === 기획전(2)
     */
    columns = [imgColumn, ...eventColumns(data)];
  } else if (tagRelatedItemType === TAG_RELATED_ITEM_TYPE.REVIEW) {
    /**
     *  태그에 연결된 아이템 타입 === 상품 후기(3)
     */
    columns = [imgColumn, ...reviewColumns(data)];
  }

  return columns;
};

/**
 *  태그에 연결된 상품 리스트 컬림
 */
export const productColumns = (data) => {
  return [
    {
      title: <TableColumnTitle title={'브랜드명'} />,
      dataIndex: 'brandName',
    },
    {
      title: <TableColumnTitle title={'브랜드 ID'} />,
      dataIndex: 'storeId',
    },
    {
      title: <TableColumnTitle title={'상품 번호'} />,
      dataIndex: 'id',
    },
    {
      title: <TableColumnTitle title={'상품명'} />,
      dataIndex: 'productName',
    },
    {
      title: <TableColumnTitle title={'1차 카테고리'} />,
      dataIndex: 'mainCategory',
    },
    {
      title: <TableColumnTitle title={'2차 카테고리'} />,
      dataIndex: 'isSubCategoryExists',
      render: (value, record) =>
        value ? (
          <Anchor
            text="카테고리 보기"
            isUnderLine
            color="primary"
            onClick={() =>
              data.getProductSubCategoryList({
                productId: record.productId,
              })
            }
          />
        ) : (
          '-'
        ),
    },
    {
      title: <TableColumnTitle title={'판매가 (원)'} />,
      dataIndex: 'originPrice',
      render: (value) => setNumberWithComma(value),
    },
    {
      title: <TableColumnTitle title={'할인가 (원)'} />,
      dataIndex: 'discountPrice',
      render: (value) => setNumberWithComma(value),
    },
    {
      title: <TableColumnTitle title={'할인율 (%)'} />,
      dataIndex: 'discountRate',
    },
    {
      title: <TableColumnTitle title={'할인기간'} />,
      dataIndex: 'discountPeriod',
    },
    {
      title: <TableColumnTitle title={'실판매가 (원)'} />,
      dataIndex: 'salesPrice',
      render: (value) => setNumberWithComma(value),
    },
    {
      title: <TableColumnTitle title={'등록일'} />,
      dataIndex: 'createDate',
      render: (value) => setDateFormat(value),
    },
  ];
};

/**
 *  태그에 연결된 브랜드 리스트 컬림
 */
export const storeColumns = () => {
  return [
    {
      title: <TableColumnTitle title={'브랜드명'} />,
      dataIndex: 'brandName',
    },
    {
      title: <TableColumnTitle title={'브랜드 ID'} />,
      dataIndex: 'id',
    },
    {
      title: <TableColumnTitle title={'브랜드 티어'} />,
      dataIndex: 'storeTier',
    },
    {
      title: <TableColumnTitle title={'브랜드 찜 수'} />,
      dataIndex: 'storeLikeCnt',
    },
    {
      title: <TableColumnTitle title={'입점 일자'} />,
      dataIndex: 'entryDate',
      render: (value) => setDateFormat(value),
    },
  ];
};

/**
 *  태그에 연결된 기획전 리스트 컬럼
 */
export const eventColumns = () => {
  return [
    {
      title: <TableColumnTitle title={'제목'} />,
      dataIndex: 'mainTitle',
    },
    {
      title: <TableColumnTitle title={'기간'} />,
      dataIndex: 'eventPeriod',
    },
  ];
};

/**
 *  태그에 연결된 상품 후기 리스트 컬림
 */
export const reviewColumns = () => {
  return [
    {
      title: <TableColumnTitle title={'별점'} />,
      dataIndex: 'rate',
    },
    {
      title: <TableColumnTitle title={'상품 번호'} />,
      dataIndex: 'productId',
    },
    {
      title: <TableColumnTitle title={'상품명'} />,
      dataIndex: 'productName',
    },
    {
      title: <TableColumnTitle title={'상품 주문번호'} />,
      dataIndex: 'orderItemId',
    },
    {
      title: <TableColumnTitle title={'구매자 ID'} />,
      dataIndex: 'buyerId',
    },
    {
      title: <TableColumnTitle title={'구매자명'} />,
      dataIndex: 'buyerName',
    },
    {
      title: <TableColumnTitle title={'구매평'} />,
      dataIndex: 'content',
    },
    {
      title: <TableColumnTitle title={'작성 일자'} />,
      dataIndex: 'createDate',
      render: (value) => setDateFormat(value),
    },
  ];
};
